import { FlexBox } from 'components/Containers/FlexBox';
import { TabletList } from './components/TabletList';

export const TabletListView = () => {
  return (
    <>
      <FlexBox sx={{ width: '100%', justifyContent: 'space-between' }}>
        <div />
        <FlexBox sx={{ display: 'flex' }} />
      </FlexBox>
      <TabletList />
    </>
  );
};
